"use strict";

require("core-js/modules/es6.array.filter");

exports.__esModule = true;
exports["default"] = cx;

function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(Boolean).join(' ');
}